export default "__VITE_ASSET__ptKsymNy__"